import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Star, MapPin, Users, TrendingUp, X, User, Phone, MapPinned, Milk } from 'lucide-react';
import '../../../assets/styles/customer/components/DistributorCard.css';

const DistributorCard = ({ distributor, featured = false }) => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    location: '',
    quantity: ''
  });

  const handleBookNow = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      name: '',
      phone: '',
      location: '',
      quantity: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Booking:', formData, distributor);
    alert('Booking request sent successfully!');
    handleCloseModal();
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<Star key={i} size={14} fill="#ffc107" color="#ffc107" />);
    }
    if (hasHalfStar) {
      stars.push(<Star key="half" size={14} fill="none" color="#ffc107" />);
    }
    const remaining = 5 - stars.length;
    for (let i = 0; i < remaining; i++) {
      stars.push(<Star key={`empty-${i}`} size={14} fill="none" color="#d0d0d0" />);
    }
    return stars;
  };

  return (
    <>
      <div className={`distributor-card-component ${featured ? 'featured-card' : ''}`}>
        {/* Featured Badge */}
        {featured && (
          <div className="featured-badge">
            <TrendingUp size={14} />
            <span>Featured</span>
          </div>
        )}

        {/* Card Image */}
        <div className="dist-card-image">
          <img src={distributor.image} alt={distributor.name} />
          <div className="image-gradient-overlay"></div>
        </div>

        {/* Card Info (Always Visible) */}
        <div className="dist-card-info">
          <h3 className="dist-card-name">{distributor.name}</h3>
          
          <div className="dist-card-location">
            <MapPin size={14} />
            <span>{distributor.location}</span>
          </div>

          <div className="dist-card-stats">
            <div className="card-stat">
              <Users size={14} />
              <span>{distributor.customers}</span>
            </div>
            <div className="stat-divider"></div>
            <div className="card-stat">
              <div className="rating-stars">
                {renderStars(distributor.rating)}
              </div>
              <span className="rating-number">({distributor.rating})</span>
            </div>
            <div className="stat-divider"></div>
            <div className="card-stat">
              <Milk size={14} />
              <span>{distributor.deliveries}</span>
            </div>
          </div>
        </div>

        {/* Hover Overlay (Slides Up) */}
        <div className="dist-card-hover-overlay">
          <p className="dist-card-description">{distributor.description}</p>
          
          <div className="price-and-action">
            <div className="price-display">
              <span className="price-label">Rs.</span>
              <span className="price-value">{distributor.price}</span>
              <span className="price-unit">/Liter</span>
            </div>
            <button className="card-book-btn" onClick={handleBookNow}>
              Book Now
            </button>
          </div>
        </div>
      </div>

      {/* Booking Modal */}
      <Modal 
        show={showModal} 
        onHide={handleCloseModal}
        centered
        className="distributor-booking-modal"
      >
        <div className="dist-modal-content">
          <button className="dist-modal-close" onClick={handleCloseModal}>
            <X size={24} />
          </button>

          <div className="dist-modal-header">
            <div className="dist-modal-logo">
              <img src={distributor.image} alt={distributor.name} />
            </div>
            <h3 className="dist-modal-title">Book from {distributor.name}</h3>
            <p className="dist-modal-subtitle">
              Fill in your details to request milk delivery from this distributor.
            </p>
            <p className="dist-modal-rate">
              Rate: <span className="rate-value">Rs. {distributor.price}/Liter</span>
            </p>
          </div>

          <form onSubmit={handleSubmit} className="dist-booking-form">
            <div className="dist-form-group">
              <label className="dist-form-label">
                <User size={18} />
                <span>Your Name</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter your full name"
                className="dist-form-input"
                required
              />
            </div>

            <div className="dist-form-group">
              <label className="dist-form-label">
                <Phone size={18} />
                <span>Phone Number</span>
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter your phone number"
                className="dist-form-input"
                required
              />
            </div>

            <div className="dist-form-group">
              <label className="dist-form-label">
                <MapPinned size={18} />
                <span>Delivery Location</span>
              </label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleInputChange}
                placeholder="Enter your delivery address"
                className="dist-form-input"
                required
              />
            </div>

            <div className="dist-form-group">
              <label className="dist-form-label">
                <Milk size={18} />
                <span>Daily Quantity (Liters)</span>
              </label>
              <input
                type="number"
                name="quantity"
                value={formData.quantity}
                onChange={handleInputChange}
                placeholder="Enter quantity in liters"
                className="dist-form-input"
                min="1"
                step="0.5"
                required
              />
            </div>

            <div className="dist-modal-actions">
              <button 
                type="button" 
                className="dist-cancel-btn"
                onClick={handleCloseModal}
              >
                Cancel
              </button>
              <button type="submit" className="dist-confirm-btn">
                Confirm Booking
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default DistributorCard;